export const isExternalLink = (link = '') => {
  link = link.trim();
  const internalLinksReg = [
    /^$/,                                                     // eq ''
    /^\/(?!\/)/,                                              // beginning with '/', no beginning with '//'
    /^(?!http(s)?:\/\/)/,                                     // no begging with 'http://' or 'https://'
    /^http(s)?:\/\/(.+\.)*theknot.com($|\/)/,                 // beginning with 'http(s)://(www.)theknot.com
    /^http(s)?:\/\/(.+\.)*thebump.com($|\/)/,
    /^http(s)?:\/\/(.+\.)*thebash.com($|\/)/,
    /^http(s)?:\/\/(.+\.)*how(they|he|she)asked.com($|\/)/,
  ];

  let isExternal = true;

  try {
    internalLinksReg.forEach((reg) => {
      if (reg.test(link)) throw new Error("isExternal");
    });
  } catch(e) {
    if(e.message === "isExternal") isExternal = false;
  }

  return isExternal;
}
